<template>
    <div>
        <!-- Style type radio buttons -->
        <b-form-group v-if="!isWfsWithGraphicalLayer">
            <b-form-radio-group
                :id="`styletype-radio-group_${themeStyle.id}`"
                v-model="styleType"
                :name="`styletype-radio-sub-component_${themeStyle.id}`"
                @change="$_onStyleTypeChanged"
            >
                <b-form-radio :value="styleTypeSimple">{{
                    $t('simpleStyle')
                }}</b-form-radio>
                <b-form-radio :value="styleTypeAdvanced">{{
                    $t('customStyle')
                }}</b-form-radio>
            </b-form-radio-group>
        </b-form-group>
        <!-- Simple style input-->
        <div v-if="displaySimpleStyleInput">
            <!-- display default style-tab directly -->
            <style-tab
                :themeStyle="themeStyle"
                :textAttributeOptions="textAttributeOptions"
                tabSelection="Default"
                name="FbStStandardSimple"
                :geometryTypeArray="geometryTypeArray"
                :isWfsWithGraphicalLayer="isWfsWithGraphicalLayer"
                :showTextAttribute="showTextAttribute"
                :isFeedback="isFeedback"
                :isLabelAllowed="!isWebFeedback"
            >
            </style-tab>
        </div>
        <!-- Advanced style input - regular layer/feedback -->
        <div v-else-if="displayAdvancedStyleInput && !isWebFeedback">
            <advanced-style-form
                :inputFields="inputFields"
                :domains="domains"
                :themeStyle="themeStyle"
                :isFeedback="isFeedback"
                @reevaluatestyle="$_onReevaluateStyle"
                :geometryTypeArray="geometryTypeArray"
                :layerSourceName="layerSourceName"
            >
            </advanced-style-form>
        </div>
        <!-- Advanced style input - web feedback -->
        <div v-else-if="displayAdvancedStyleInput && isWebFeedback">
            <!-- display original style-tab in one of the tabs -->
            <b-tabs content-class="mt-3" v-model="tabIndex">
                <!-- Cluster -->
                <b-tab :title="tabTitleCluster">
                    <style-tab
                        :themeStyle="themeStyle"
                        tabSelection="Default"
                        name="FbStStandardAdvanced"
                        :geometryTypeArray="geometryTypeArray"
                    >
                    </style-tab>
                </b-tab>
                <!-- Geavanceerd -->
                <b-tab :title="tabTitleAdvanced">
                    <advanced-style-form
                        :inputFields="inputFields"
                        :themeStyle="themeStyle"
                        :isFeedback="isFeedback"
                        :geometryTypeArray="geometryTypeArray"
                    >
                    </advanced-style-form>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    import styleTab from '../../../components/dashboard/StylingOptions/StyleTab.vue';
    import advancedStyleForm from './AdvancedStyleForm.vue';
    import { ADVANCED_STYLE_TAB_INDEX, STYLE_CLASSIFICATION_TYPES } from '../../../constants';

    export default {
        name: 'styleTab',

        components: {
            'style-tab': styleTab,
            'advanced-style-form': advancedStyleForm
        },
        props: {
            selectedStyle: { type: Object, required: false },
            textAttributeOptions: {
                type: Array,
                required: false,
                default: () => []
            },
            inputFields: { type: Array, required: false, default: () => [] },
            domains: { type: Array, required: false, default: () => [] },
            name: { type: String, required: false, default: '' },
            isWebFeedback: { type: Boolean, required: false, default: false },
            isFeedback: { type: Boolean, required: false, default: false },
            isWfsWithGraphicalLayer: {
                type: Boolean,
                required: false,
                default: false
            },
            geometryTypeArray: { type: Array, required: false, default: () => [] },
            layerSourceName: {
                type: String,
                required: false,
                default: ''
            }
        },

        data: function () {
            return {
                themeStyle: this.selectedStyle,
                styleTypeSimple: 'simple',
                styleTypeAdvanced: 'advanced',
                styleType: '',
                tabTitleCluster: '',
                tabTitleAdvanced: '',
                tabIndex: ADVANCED_STYLE_TAB_INDEX.TAB_CLUSTER
            };
        },

        computed: {
            displaySimpleStyleInput() {
                return this.styleType === this.styleTypeSimple;
            },
            displayAdvancedStyleInput() {
                return (
                    this.styleType === this.styleTypeAdvanced &&
                    this.themeStyle.customStylingOptions?.attribute !== undefined
                );
            },
            showTextAttribute() {
                // show text attribute if there is no attribute selected in the advanced label tab.
                return !this.textAttributeOptions.some((i) => i.isTextAttribute);
            }
        },

        mounted() {
            this.tabTitleCluster = this.$t('tabTitleCluster');
            this.tabTitleAdvanced = this.$t('tabTitleAdvanced');
            if (this.themeStyle.customStylingOptions) {
                this.styleType = this.styleTypeAdvanced;
            } else {
                this.styleType = this.styleTypeSimple;
            }
        },

        methods: {
            $_onReevaluateStyle() {
                this.$emit('reevaluatestyle');
            },
            $_onStyleTypeChanged(evt) {
                if (evt === this.styleTypeAdvanced) {
                    this.$_initializeCustomStylingOptions();
                } else {
                    this.$_clearCustomStylingOptions();
                }
            },
            $_clearCustomStylingOptions() {
                this.themeStyle.customStylingOptions = null;
            },
            $_initializeCustomStylingOptions() {
                const customStyling = {
                    rules: [],
                    domainId: null,
                    attribute: null,
                    colorStart: 'rgba(255, 0, 0, 1)',
                    colorEnd: 'rgba(0, 0, 255, 1)',
                    classificationType: STYLE_CLASSIFICATION_TYPES.NOMINAL
                };
                this.themeStyle.customStylingOptions = { ...customStyling };
            }
        },
        watch: {
            tabIndex: function (newVal, oldVal) {
                this.$emit('updateTabIndex', this.tabIndex);
            }
        }
    };
</script>
